import { Action, any, async, fromJSX, loadingAsyncState, nothing, stateful } from "widgets-for-react";
import { previousOrDefault } from "../../../../Shared/utils/asyncState";
import { BlogsResponse, getBlogs } from "./blogOverviewApi";
import { BlogOverviewLayout } from "./blogOverviewLayout";
import { BlogOverviewProps, BlogOverviewState, initialBlogResponse as initialBlogsResponse, initialState, resultsClass } from "./blogOverviewState";
import { Category } from "../../../../Shared/api/drupal/drupalTypes";

export const BlogOverview = (props: BlogOverviewProps) =>
  stateful<BlogOverviewState>()(s0 =>
    any<Action<BlogOverviewState>>()([
      fromJSX(setState => BlogOverviewLayout({
        ...s0,
        ...props,
        key: 'blogOverview',
        setPage: (page) => setState((s0 => ({
          ...s0,
          currentPage: page,
          blogpostLoader: loadingAsyncState(getBlogs(page, props.pageSize, s0.selectedCategory), previousBlogsResponse(s0))
        }))),
        setCategory: (newCategory) => setState(s0 => {
          // Always go to the first page when switching category
          const currentPage = 1

          // Clicking the active Category a second time will turn of category filtering
          const selectedCategory = newCategory.slug == s0.selectedCategory ? null : newCategory.slug

          const fetcher = getBlogs(currentPage, props.pageSize, selectedCategory)
          const blogpostLoader = loadingAsyncState(fetcher, previousBlogsResponse(s0))

          return { ...s0, selectedCategory, blogpostLoader, currentPage }
        })
      })),
      async<BlogsResponse>(nothing, { key: 'blogsLoader' })(s0.blogpostLoader)
        .map(postsUpdater => s1 => {
          const blogpostLoader = postsUpdater(s1.blogpostLoader)
          if (blogpostLoader.kind == 'loaded') scrollResultsToTop()
          return { ...s1, blogpostLoader }
        }),
      async<Category[]>(nothing, { key: 'blogCategoriesLoader' })(s0.blogCategoriesLoader)
        .map(categoriesUpdater => s1 => {
          const blogCategoriesLoader = categoriesUpdater(s1.blogCategoriesLoader)
          return { ...s1, blogCategoriesLoader }
        })
    ]).map(a => a(s0))
  )(initialState(props)).run(_ => { })

const previousBlogsResponse = (s0: BlogOverviewState) => previousOrDefault(s0.blogpostLoader, initialBlogsResponse)

const scrollResultsToTop = () => document
  .getElementsByClassName(resultsClass)[0]
  .scrollIntoView({ behavior: "smooth" })
